<template>
    <transition name="fade" >
      <div v-if="visible" class="panel f-column window window-shadow custom-alert">
        <div class="f-row f-vcenter panel-header f-noshrink panel-header-noborder window-header"  >  
          <div v-if="type === 'info'" class="panel-title">Info</div>
          <div v-if="type === 'error'" class="panel-title">Error</div>
          <div v-if="type === 'question'" class="panel-title">Question</div>
          <div v-if="type === 'warning'" class="panel-title">Warning</div>
          <div class="panel-tool"><!----> 
            <a class="panel-tool-close" @click="closeDialog"></a>
          </div>
        </div> 
        <div class="f-column panel-body f-full panel-body-noborder window-body">
          <div class="f-column f-full">
            <div class="messager-body f-full f-column">
              <div class="f-row f-full">
                <div v-if="type === 'error'" class="f-noshrink messager-icon messager-error"></div> 
                <div v-if="type === 'question'" class="f-noshrink messager-icon messager-question"></div> 
                <div v-if="type === 'warning'" class="f-noshrink messager-icon messager-warning"></div> 
                <div class="f-full">
                {{ message }}
                </div>
              </div> 
            </div> 
          </div>
            <!-- <div class="dialog-button messager-button f-noshrink">
              <a href="#" class="l-btn f-inline-row f-content-center l-btn-small">
                <span class="l-btn-left">
                  <span class="l-btn-text">Ok</span> 
                  <span class="l-btn-icon"></span>
                </span>
              </a>
            </div> -->
        </div> 
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'Dialog',
    props: {
      message: {
        type: String,
        default: 'Hello!'
      },
      type: {
        type: String,
        default: 'info'
      },
      duration: {
        type: Number,
        default: 3000
      }
    },
    data() {
      return {
        visible: false
      };
    },
    mounted() {
      this.showAlert();
    },
    methods: {
      showAlert() {
        this.visible = true;
        if (this.duration) {
          setTimeout(() => {
            this.hideAlert();
          }, this.duration);
        }
      },
      closeDialog(){
        this.hideAlert();
      },
      hideAlert() {
        this.visible = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .custom-alert {
    display: flex;
    width: 250px;
    border-radius: 4px;
    position: fixed;
    right: 10px;
    bottom: 10px;
    z-index: 10000;
    pointer-events: auto;
    transition: opacity 0.3s, transform 0.4s;
    box-shadow: 2px 2px 3px #cccccc;
    opacity: 0.95;
  }
  .panel-tool-close{
    cursor:pointer;
  }
  .f-full{
    word-break:break-all;
    min-height: 60px;
  }
  .messager-body{
    padding:10px;
  }
  
  .success {
    background-color: #86cf86;
    color: white;
  }
  
  .error {
    background-color: #f44336;
    color: white;
  }
  
  .info {
    background-color: #1e90ff;
    color: white;
  }
  
  .warning {
    background-color: #ffeb3b;
    color: black;
  }

  @keyframes moveTop {
    0% {
      transform: translateY(calc(100%));
    }
    100% {
      transform: translateY(0);
    }
  }
  
  @keyframes moveBottom {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(calc(100%));
    }
  }
  .fade-enter-active{
      animation: moveTop 0.5s ; 
  }
  .fade-leave-active{
      animation: moveBottom 0.5s ; 
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
  </style>
  